import { de as reactDe } from '@ews/react-translations';

const de = {
    ...reactDe,


    "[REACT_ALARM_TIME_RANGE]": "Zeitraum",
    "[REACT_ALARM_COUNTER_LABEL]": "Alarmzählerstand",
    "[REACT_LOGOUT]": "Manuelles Ausloggen",
    "[REACT_LOGOUT_DIALOG_CONTENT]": "Möchten Sie %{user} wirklich manuell ausloggen",
    "COM_FACPMANAGEMENT_USER_ACCOUNT_NOTIFICATIONS_MAILS": "E-Mail-Nachrichten bei",
    "[SID_DLG_HEADER_SIMULATIONEND]": "Beende Simulation",
    "[REACT_SIMULATE_USER]": "Benutzer Anmeldung simulieren",
    "[CONFIRM_SIMULATE_USER]": "Sind Sie sicher, dass Sie zu diesem Benutzer die Anmeldung simulieren wollen?",
    "[REACT_SIMULATION_STARTING]": "Starte Simulation",
    "[REACT_SIMULATION_ACTIVE]": "Simulation",
    "[REACT_SIMULATION_ENDING]": "Beende Simulation",
    "[REACT_CREATE_SYSTEM_SHARE_DURATION]": "Zeitdauer",
    "[REACT_CREATE_SYSTEM_SHARE_INTERVALL]": "Zeitraum",
};

export default de;
